import { render, staticRenderFns } from "./tinymceEditor.vue?vue&type=template&id=fbb6a820&scoped=true"
import script from "./tinymceEditor.vue?vue&type=script&lang=js"
export * from "./tinymceEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb6a820",
  null
  
)

export default component.exports